export const VIDEO_EXTENSIONS = [".mp4", ".mov", ".webm", ".avi", ".mkv"];
export const VIDEO_QUALITY_SUFFIX_720 = "-720";
export const VIDEO_QUALITY_SUFFIX_1080 = "-1080";
export const VIDEO_QUALITY_SUFFIXES = [
	VIDEO_QUALITY_SUFFIX_1080,
	VIDEO_QUALITY_SUFFIX_720,
] as const;
export const PDF_EXTENSIONS = [".pdf"];
export const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".webp"];

export const ACCEPTED_FILE_TYPES = [...VIDEO_EXTENSIONS, ...PDF_EXTENSIONS];
export const THUMBNAIL_TYPES = [".jpg", ".jpeg", ".png"];
export const DEFAULT_MIME_TYPE = "application/octet-stream";

export const FILE_MIME_TYPES: Record<string, string> = {
	pdf: "application/pdf",
	doc: "application/msword",
	docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	xls: "application/vnd.ms-excel",
	xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	ppt: "application/vnd.ms-powerpoint",
	pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	txt: "text/plain",
	jpg: "image/jpeg",
	jpeg: "image/jpeg",
	png: "image/png",
	gif: "image/gif",
	zip: "application/zip",
	rar: "application/x-rar-compressed",
	mp4: "video/mp4",
	mov: "video/quicktime",
	webm: "video/webm",
	avi: "video/x-msvideo",
	mkv: "video/x-matroska",
};

export const MAX_PDF_FILE_SIZE_MB = 1024 * 1024 * 50; // 50 MB
export const MAX_VIDEO_FILE_SIZE_MB = 1024 * 1024 * 8000; // 8000 MB (~6.84 GB)
export const OTHER_FILES_SIZE_LIMIT_MB = 1024 * 1024 * 100; // 100 MB
